import axios from 'axios';

const CheckUserService = {
  /**
   * Check if a user exists by email
   * @param {string} email - The email address to check
   * @returns {Promise<Object>} - The response data from the server
   */
  checkUser: async (email) => {
    const response = await axios.get('/users/check_user', {
      params: { email },
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  }
};

export default CheckUserService;
